import hljs from 'highlight.js';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';
import { html } from "lit";
import { css } from "nested-css-to-flat/lit-css";
import { unsafeHTML } from "lit/directives/unsafe-html";
import { pureLit, useState, useOnce } from "pure-lit";

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('html', xml);

fetch("/js/code-interactive/darcula.css")
    .then(response => response.text())
    .then(styles => {
        pureLit("highlight-code", async (el) => {
            const { location } = el;
            const show = el.show.split(",")
            const tab = useState(el, show[0])
            const views = useState(el, { code: html``, html: html``, preview: html`` });
            useOnce(el, async () => {
                const [code, xml] = await Promise.all([
                    fetch(`${location}/index.js`).then(response => response.status < 399 ? response.text() : Promise.resolve("")),
                    fetch(`${location}/index.html`).then(response => response.status < 399 ? response.text() : Promise.resolve(""))
                ]);
                views.set({
                    code: html`<section><pre><code class="hljs">${unsafeHTML(hljs.highlight(code, { language: 'javascript' }).value)}</code></pre></section>`,
                    html: html`<section><pre><code class="hljs">${unsafeHTML(hljs.highlight(xml, { language: 'html' }).value)}</code></pre></section>`,
                    preview: html`<section>
                    <iframe srcdoc="${("<style>html, body, span, p, h1, h2, h3, h4, h5, div {color: rgb(233, 233, 244);} </style><script type='module'>" + code + "</script>" + xml)}"></iframe>
                </section>`
                })
            })

            return html`
            <article class="tabs">
                <ul>
                    ${show.map(entry => html`<li class="${entry === tab.get() ? "active" : ""}" @click="${() => tab.set(entry)}">${entry}</li>`)}
                </ul>
                ${views.get()[tab.get()] || null}
            </article>`;
        }, {
            styles: [
                css`
                    iframe {
                        border: 0;
                        width: 100%;
                        height: 100%;
                        background: rgb(40, 41, 54);
                        color: rgb(233, 233, 244);
                    }
                    ul {
                        margin: 0;
                        padding:0;
                        list-style: none;
                        display: flex;
                        width: 100%;

                        & li {
                            cursor: pointer;                        
                            flex-grow: 1;
                            padding: 0px 20px;
                        }
                        & li:hover {
                            font-style: italic;
                            border-bottom: 3px solid rgb(235, 255, 135);
                        }
                        & li.active {
                            font-style: italic;
                            border-bottom: 3px solid #ff79c6;
                        }
                    }
                    article {
                        & section
                        {
                            box-shadow: 0 3px 3px rgba(0,0,0,0.1);
                            z-index: 0;

                            &:target
                            {
                                display: block;
                            }
                        }
                    }

                    pre {
                        margin-top: 0;
                    }
                    pre code {
                        display: block;
                        overflow-x: auto;
                        padding: 1em;
                        font-size: smaller;
                    }
                    ${styles}`
            ],
            defaults: {
                location: "",
                show: "code,html,preview"
            }
        });
    })


